import { MiddleLayer } from "./MiddleLayer";
//Mock Comms
// import { MockServer } from "./server/MockServer";

import { HTTPServer } from "./server/HTTPServer";
import { TutorialServer } from "./server/TutorialServer";

var serverURI = 'https://1h.shake-it-up.net';
// var serverURI = 'https://prod.shake-it-up.net';

export const comm = new MiddleLayer(new HTTPServer(serverURI), new TutorialServer());

window.comm = comm;
